import TitlePreReleaseTemplate from '../../templates/TitlePreRelease.html';

export default class TitlePreRelease extends Backbone.View {
    template = TitlePreReleaseTemplate;

    constructor() {
        super(...arguments);

        if(!!this.model.get('isPreReleaseTitle')) {
            this.render();
        }
    }

    render() {
        this.setElement($(this.template({date: this.model.get('estimatedReleaseDate')})));
    }
}
